import axios from 'axios'
import qs from 'qs'
import { SIGNIN_ROUTE } from 'routes'
import { ruCulture } from './languages'
console.log(window.API_URL)
console.log(`${process.env.REACT_APP_API_URL}api/`)

const rawApiUrl = window.API_URL || process.env.REACT_APP_API_URL || ''
const normalizedApiUrl = rawApiUrl.replace(/\/+$/, '')

const apiV1 = axios.create({
  baseURL: `${normalizedApiUrl}/api/`,
})

const setupAxiosInterceptors = (appStore, authStore) => {
  apiV1.interceptors.request.use(
    async req => {
      if (req.url === '/api/Token/Refresh') {
        authStore.setIsPending(true)
      }
      return {
        ...req,
        headers: {
          ...req.headers,
          'Accept-Language': appStore.currentLanguage === ruCulture ? 'ru-RU' : 'en-US',
          Authorization: authStore.user?.accessToken ? `Bearer ${authStore.user.accessToken}` : undefined,
        },
        paramsSerializer: params => qs.stringify(params, { allowDots: true, skipNulls: true }),
      }
    },
    error => Promise.reject(error),
  )

  apiV1.interceptors.response.use(
    response => {
      const contentType = response.headers?.['content-type'] ?? ''
      if (typeof response.data === 'string' && contentType.includes('text/html')) {
        return Promise.reject(new Error('Proxy error: received HTML instead of JSON'))
      }
      return response
    },
    async error => {
      const originalRequest = error.config

      if (error.response?.status === 401 && originalRequest.url === '/api/Token/Refresh' && !authStore.isPending) {
        authStore.signOut()
        window.location.href = SIGNIN_ROUTE
        return Promise.reject(error)
      }

      if (error.response?.status === 401 && !originalRequest._retry && !authStore.isPending) {
        try {
          originalRequest._retry = true
          const refreshToken = authStore.user.refreshToken

          const response = await authStore.refreshToken({
            refreshToken,
          })

          apiV1.defaults.headers.common['Authorization'] = `Bearer ${response.data.accessToken}`

          await apiV1(originalRequest)
          authStore.setIsPending(false)
        } catch (e) {
          authStore.setIsPending(false)
          authStore.signOut()
          window.location.href = SIGNIN_ROUTE
        }
      }

      return Promise.reject(error)
    },
  )
}

export { setupAxiosInterceptors, apiV1 }
